import { content, alert } from "../../utils/Modal";

export const PeopleController = {
    index(): void {
        this._initCardModal();
    },

    _initCardModal(): void {
        const grid = document.getElementById("people-grid");
        if (!grid) { return; }

        const open = (card: HTMLElement): void => {
            const slug = card.dataset.personSlug ?? "";
            const name = card.dataset.personName ?? "";
            if (!slug) { return; }

            fetch(`/about/people/${encodeURIComponent(slug)}?modal=1`)
                .then((r) => {
                    if (!r.ok) { throw new Error(String(r.status)); }
                    return r.text();
                })
                .then((html) => content(html, name, "wide"))
                .catch(() => alert("Failed to load profile. Please try again."));
        };

        grid.addEventListener("click", (e: MouseEvent) => {
            const card = (e.target as HTMLElement).closest<HTMLElement>("[data-person-card]");
            if (!card) { return; }
            // TG/CP 태그 링크 클릭은 모달 열지 않고 페이지 이동
            if ((e.target as HTMLElement).closest("a")) { return; }
            e.preventDefault();
            open(card);
        });

        // 키보드 접근성: Enter / Space 로도 모달 오픈
        grid.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.key !== "Enter" && e.key !== " ") { return; }
            const card = (e.target as HTMLElement).closest<HTMLElement>("[data-person-card]");
            if (!card) { return; }
            e.preventDefault();
            open(card);
        });
    },
};
